import FundCharts from './FundCharts'

export default FundCharts
